import Email from "./email";

const translations: Record<string, JSX.Element> = {
  pt: (
    <>
      <p>Carinhas por: <a href="https://www.instagram.com/carinhas.co/">Isabela Reinhold</a></p>
      <p>Museu por: <a href="https://cgreinhold.dev/">Cleyson Reinhold</a></p>
    </>
  ),
  en: (
    <>
      <p>Paintings by: <a href="https://www.instagram.com/carinhas.co/">Isabela Reinhold</a></p>
      <p>Museum by: <a href="https://cgreinhold.dev/">Cleyson Reinhold</a></p>
    </>
  )
}

const Credits: React.FC = () => {
  return (
    <div>
      {
        translations[window.location.pathname.substring(1)] ||
        translations['pt']
      }

      <Email />
    </div>
  );
}

export default Credits;
